var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { attrs: { shadow: "always", "body-style": { padding: "20px" } } },
    [
      _c(
        "el-descriptions",
        {
          attrs: { title: "账单详情", column: 5 },
          scopedSlots: _vm._u(
            [
              _vm.detail &&
              _vm.detail.clearing_form_type ===
                _vm.SETTLEMENT_OPTIONS.BILL_PAYMENT &&
              _vm.detail.status === _vm.STATUS.BILLS_TO_BE_PAID
                ? {
                    key: "extra",
                    fn: function() {
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "16px" },
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.handleShowDoneDialog }
                          },
                          [_vm._v("\n        线下支付\n      ")]
                        )
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        [
          _vm.detail && _vm.detail.status === _vm.STATUS.PENDING_BUSINESS_REVIEW
            ? _c(
                "template",
                { slot: "extra" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showConfirmDialog }
                    },
                    [_vm._v("\n        提交账单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "small" },
                      on: { click: _vm.handleBillCancel }
                    },
                    [_vm._v("\n        作废\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.detail &&
          _vm.detail.status === _vm.STATUS.PENDING_FINANCIAL_REVIEW
            ? _c(
                "template",
                { slot: "extra" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "16px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showConfirmReviewPassDialog }
                    },
                    [_vm._v("\n        审核通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showReviewRejectDialog }
                    },
                    [_vm._v("\n        审核驳回")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "账单编号" } }, [
            _vm._v(_vm._s(_vm.detail && _vm.detail.bill_no))
          ]),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "账单生成时间" } }, [
            _vm._v(_vm._s(_vm.detail && _vm.detail.created_at))
          ]),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "账期" } }, [
            _vm._v(_vm._s(_vm.detail && _vm.detail.reporting_period) + "\n    ")
          ]),
          _vm._v(" "),
          _vm.detail &&
          (_vm.detail.status === _vm.STATUS.PENDING_PURCHASE_ORDER_DEDUCTION ||
            _vm.detail.status === _vm.STATUS.BILLS_TO_BE_PAID ||
            _vm.detail.status === _vm.STATUS.DONE)
            ? _c("el-descriptions-item", { attrs: { label: "账单确认时间" } }, [
                _vm._v(_vm._s(_vm.detail && _vm.detail.confirm_time) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-descriptions-item",
            {
              attrs: {
                label: "账单状态",
                "content-style": {
                  "font-weight": "bold",
                  color: "#333",
                  "font-size": "18px",
                  "line-height": "18px"
                }
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    disabled: !(_vm.detail && _vm.detail.remark),
                    effect: "dark",
                    content: _vm.detail && _vm.detail.remark,
                    placement: "top-start"
                  }
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.detail && _vm.detail.status_msg))
                  ])
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogRejectVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogRejectVisible = $event
            },
            close: _vm.handleRejectClose
          }
        },
        [
          _c("div", [_vm._v("确定账单审核驳回？")]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "rejectForm",
              attrs: {
                model: _vm.rejectForm,
                rules: _vm.rejectRules,
                "label-width": "0px",
                inline: false,
                size: "normal"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入原因，最多50个字",
                      size: "normal",
                      maxlength: 50,
                      clearable: "",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.rejectForm.reason,
                      callback: function($$v) {
                        _vm.$set(_vm.rejectForm, "reason", $$v)
                      },
                      expression: "rejectForm.reason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogRejectVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmReject }
                },
                [_vm._v(" 确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传凭证",
            visible: _vm.dialogDoneVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogDoneVisible = $event
            },
            close: _vm.handleDoneClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formDone",
              attrs: {
                model: _vm.formDone,
                rules: _vm.doneRules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "凭证图片", prop: "receipt" } },
                [
                  _c("ys-upload", {
                    attrs: { max: _vm.constantMap.maxImage },
                    model: {
                      value: _vm.formDone.receipt,
                      callback: function($$v) {
                        _vm.$set(_vm.formDone, "receipt", $$v)
                      },
                      expression: "formDone.receipt"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogDoneVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmDone }
                },
                [_vm._v(" 确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogConfirmSubmitVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogConfirmSubmitVisible = $event
            },
            close: _vm.handleConfirmSubmitClose
          }
        },
        [
          _c("span", [_vm._v("确定提交账单？")]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogConfirmSubmitVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmSubmit }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogConfirmReviewPassVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogConfirmReviewPassVisible = $event
            },
            close: _vm.handleConfirmReviewPassClose
          }
        },
        [
          _c("span", [_vm._v("确定账单审核通过？")]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogConfirmReviewPassVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmReviewPass }
                },
                [_vm._v("\n        确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" }
        },
        [
          _c(
            "div",
            {
              staticClass: "header-bar",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between"
              }
            },
            [
              _c("div", [
                _c("span", { staticStyle: { "margin-right": "16px" } }, [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("商家ID：")
                  ]),
                  _c("span", { staticStyle: { color: "#666" } }, [
                    _vm._v(_vm._s(_vm.detail && _vm.detail.supply_id))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-right": "16px" } }, [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("商家名称：")
                  ]),
                  _c("span", { staticStyle: { color: "#666" } }, [
                    _vm._v(_vm._s(_vm.detail && _vm.detail.supply_name))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-right": "16px" } }, [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("让利计费规则获取时间：")
                  ]),
                  _c("span", { staticStyle: { color: "#666" } }, [
                    _vm._v(_vm._s(_vm.detail && _vm.detail.rule_get_time))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.detail &&
              _vm.detail.status === _vm.STATUS.PENDING_BUSINESS_REVIEW
                ? _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _c("span", [_vm._v("让利计费规则：")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning", size: "small" },
                          on: { click: _vm.showRefetchConfirmDialog }
                        },
                        [_vm._v("重新获取计费规则并更新账单")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "提示",
                    visible: _vm.dialogRefetchConfirmVisible,
                    width: "30%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogRefetchConfirmVisible = $event
                    },
                    close: _vm.handleRefetchConfirmClose
                  }
                },
                [
                  _c("div", [_vm._v("确定重新获取计费规则并更新账单？")]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "0px",
                        inline: false,
                        size: "normal"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "reason" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入原因，最多50个字",
                              size: "normal",
                              maxlength: 50,
                              clearable: "",
                              "show-word-limit": ""
                            },
                            model: {
                              value: _vm.form.reason,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "reason", $$v)
                              },
                              expression: "form.reason"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.dialogRefetchConfirmVisible = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleConfirmRefetch }
                        },
                        [_vm._v("\n            确定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: { data: _vm.tableAccountingRules, border: "", stripe: "" }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", width: "50", label: "序号" }
              }),
              _vm._v(" "),
              _vm._l(_vm.columnsAccountingRules, function(col, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: { prop: col.prop, label: col.label, width: col.width }
                })
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" }
        },
        [
          _c(
            "div",
            {
              staticClass: "header-bar",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between"
              }
            },
            [
              _c("span", [_vm._v("商品销量汇总表")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.exportList }
                    },
                    [_vm._v("\n          导出列表")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.exportGoodsDetail }
                    },
                    [_vm._v("\n          导出商品明细")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableSalesVolumeSummary,
                border: "",
                stripe: "",
                "show-summary": "",
                "summary-method": _vm.getSummariesForSalesVolume,
                "max-height": 850
              }
            },
            [
              _vm._l(_vm.columnsSalesVolumeSummary, function(col, index) {
                return [
                  col.prop === "goods_no"
                    ? _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: col.prop,
                          label: col.label,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "text-decoration": "none"
                                      },
                                      attrs: {
                                        href:
                                          (_vm.isProduction
                                            ? "https://d0k0.yishouapp.com"
                                            : "http://test1.yishou.com") +
                                          "/newos/goods/goodsLibList?goods_no=" +
                                          scope.row.goods_no,
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.goods_no))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: col.prop,
                          label: col.label,
                          width: col.width
                        }
                      })
                ]
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" }
        },
        [
          _c("div", { staticClass: "header-bar" }, [
            _c("span", [_vm._v("销售达标汇总表")])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableReachSalesTargetSummary,
                border: "",
                stripe: "",
                "show-summary": "",
                "summary-method": _vm.getSummariesForReachSalesTarget
              }
            },
            _vm._l(_vm.columnsReachSalesTargetSummary, function(col, index) {
              return _c("el-table-column", {
                key: index,
                attrs: { prop: col.prop, label: col.label, width: col.width }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" }
        },
        [
          _c("div", { staticClass: "header-bar" }, [
            _c("span", [_vm._v("金额明细")])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.tableAmountDetails, border: "", stripe: "" } },
            _vm._l(_vm.columnsAmountDetails, function(col, index) {
              return _c("el-table-column", {
                key: index,
                attrs: { prop: col.prop, label: col.label, width: col.width }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.detail &&
      _vm.detail.clearing_form_type === _vm.SETTLEMENT_OPTIONS.BILL_PAYMENT &&
      (_vm.detail.status === _vm.STATUS.BILLS_TO_BE_PAID ||
        _vm.detail.status === _vm.STATUS.DONE)
        ? _c(
            "el-card",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { shadow: "never" }
            },
            [
              _c("div", { staticClass: "header-bar" }, [
                _c("span", [_vm._v("支付流水明细")])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.tableWaterBills, border: "", stripe: "" }
                },
                [
                  _vm._l(_vm.columnsWaterBills, function(col) {
                    return [
                      col.prop === "receipt"
                        ? [
                            _c("el-table-column", {
                              key: col.prop,
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("img", {
                                          staticStyle: {
                                            width: "60px",
                                            height: "60px"
                                          },
                                          attrs: { src: row.receipt[0] },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleViewImages(
                                                row.receipt
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        row.receipt && row.receipt.length
                                          ? _c("span", [
                                              _vm._v(
                                                "共" +
                                                  _vm._s(row.receipt.length) +
                                                  "张"
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ]
                        : [
                            _c("el-table-column", {
                              key: col.prop,
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width
                              }
                            })
                          ]
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.detail &&
      _vm.detail.clearing_form_type ===
        _vm.SETTLEMENT_OPTIONS.PURCHASE_ORDER_DEDUCTION &&
      (_vm.detail.status === _vm.STATUS.PENDING_PURCHASE_ORDER_DEDUCTION ||
        _vm.detail.status === _vm.STATUS.DONE)
        ? _c(
            "el-card",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { shadow: "never" }
            },
            [
              _c("div", { staticClass: "header-bar" }, [
                _c("span", [_vm._v("代采单抵扣列表")])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableDeductionForPurchasing,
                    border: "",
                    stripe: "",
                    "max-height": 850,
                    "show-summary": "",
                    "summary-method": _vm.getSummariesForDeductionForPurchasing
                  }
                },
                [
                  _vm._l(_vm.columnsDeductionForPurchasing, function(
                    col,
                    index
                  ) {
                    return [
                      col.prop === "wcg_id"
                        ? _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "text-decoration": "none"
                                          },
                                          attrs: {
                                            href:
                                              (_vm.isProduction
                                                ? "https://erpweb.yishouapp.com"
                                                : "http://erp26.yishou.com:8088") +
                                              "/erp/#/home/purchaseorderdetail/" +
                                              scope.row.wcg_id,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(_vm._s(scope.row.wcg_id))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width
                            }
                          })
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" }
        },
        [
          _c("div", { staticClass: "header-bar" }, [
            _c("span", [_vm._v("操作日志")])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableLogs,
                border: "",
                stripe: "",
                "max-height": 850
              }
            },
            [
              _vm._l(_vm.columnsLogs, function(col, index) {
                return [
                  col.prop === "remark"
                    ? _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: col.prop,
                          label: col.label,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "8px" } },
                                    [_vm._v(_vm._s(scope.row.remark))]
                                  ),
                                  scope.row.operate_type === "2" &&
                                  scope.row.remark
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              return _vm.viewSnapshot(
                                                scope.row.log_id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("\n              查看快照")]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: col.prop,
                          label: col.label,
                          width: col.width
                        }
                      })
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "让利计费规则",
                visible: _vm.dialogSnapshotVisible,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogSnapshotVisible = $event
                },
                close: _vm.handleConfirmSubmitClose
              }
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableAccountingRulesSnapshot,
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", width: "50", label: "序号" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.columnsAccountingRulesSnapshot, function(
                    col,
                    index
                  ) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18150c0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18150c0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VendorProfitConcessionDetail/VendorProfitConcessionDetail.vue
// module id = null
// module chunks = 